export const normalizePermissionForDisplay = permission => {
    return permission === "read" ? "view" : "edit";
};
